import { isMoment } from 'moment';
import { moment } from '../';
import DateFormats from 'constants/DateFormats';

export function momentParser(m) {
  if (!m) {
    return '';
  }
  if (isMoment(m)) {
    return m.defaultServerFormat();
  }
  return moment(m, DateFormats.long_dash).defaultServerFormat();
}

export function numberParser(value) {
  return Number(value);
}

export function booleanParser(value) {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return false;
}

export const toBooleanParser = (value) => !!value;

export function rangeMomentParser(value) {
  if (!value) {
    return ['', ''];
  }
  return value.map((i) => momentParser(i));
}

export const selectValueParser = ({ value }) => value;
